import { Box } from '@mui/material';
import { usePatientReportList } from 'app/hooks/usePatientReportList';
import { Button, DetailWrapperDiv, FlatList, TextField } from 'app/shared';
import { formatDate } from 'app/utils';
import { IReportStatus } from 'generated/axios';
import { t } from 'i18next';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  id: string;
}

export const PatientReportListTab = ({ id }: Props) => {
  const { list, loading, count, create, handleFilter } = usePatientReportList(id);

  const navigate = useNavigate();

  const [search, setSearch] = useState<string>();

  const handleSearch = (newSearch?: string) => {
    setSearch(newSearch);
  };

  const getReportStatus = (status: IReportStatus | undefined) => {
    switch (status) {
      case 'draft':
        return t('report.status.draft');
      case 'processed':
        return t('report.status.processed');
      case 'confirmed':
        return t('report.status.confirmed');
      case 'error':
        return t('report.status.error');
      default: //in case of new non-translated values
        return status ?? '';
    }
  };

  return (
    <DetailWrapperDiv>
      <Box gap={2} paddingBottom={2} width={'40%'} display={'flex'} alignItems={'center'}>
        <TextField
          value={search}
          size="small"
          onChange={(e) => handleSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleFilter(search);
              e.preventDefault();
            }
          }}
        />

        <Button
          onClick={() => {
            handleFilter(search);
          }}
        >
          {t('actions.search')}
        </Button>
      </Box>
      <Box textAlign={'left'}>
        <FlatList
          list={list}
          loading={loading}
          count={count}
          keyGetter={(el) => el.id}
          onItemClick={(el) => navigate(el.id)}
          actions={[<Button onClick={create}>{t('actions.create')}</Button>]}
          fields={[
            {
              title: t('common.createdAt'),
              key: 'created_at',
              valueGetter: (item) => formatDate(item.created_at),
            },
            {
              title: t('common.status'),
              key: 'report_status',
              valueGetter: (item) => getReportStatus(item.report_status),
            },
            {
              title: t('common.doctor'),
              valueGetter: ({ doctor }) => (doctor?.last_name ?? '') + ' ' + (doctor?.first_name ?? ''),
            },
          ]}
        />
      </Box>
    </DetailWrapperDiv>
  );
};
